"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = ["href"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
        class: "card-help",
        onClick: _cache[0] || (_cache[0] =
            (...args) => (_ctx.click && _ctx.click(...args)))
    }, [
        (0, vue_1.createElementVNode)("a", {
            href: _ctx.url,
            target: "_blank"
        }, "?", 8, _hoisted_1)
    ]));
}
